import { useMutation } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';

export interface GuideStructureParams {
  topic: string;
  questions: string[];
  answers: string[];
  requestId?: string;
}

export interface GuideModule {
  moduleTitle: string;
  objective: string;
  estimatedTimeMinutes: string;
  keyQuestions: string[];
  suggestedContentFormats: string[];
  imagePrompt: string;
}

export interface GuideStructure {
  courseTitle: string;
  estimatedTotalTimeMinutes: number;
  modules: GuideModule[];
}

/**
 * Custom hook for generating a training structure based on topic and context questions
 */
export function useGenerateGuideStructureMutation() {
  return useMutation<{ message: string; status: string }, Error, GuideStructureParams>({
    mutationFn: async (params: GuideStructureParams) => {
      const response = await FetchPromise.post('/deep-research/generate', params);

      if (!response) {
        throw new Error('Failed to initiate training structure generation');
      }

      return response;
    },
  });
}
